import { useParams } from 'react-router-dom';
import ReminderCategoriesDetails from './components/reminderCategoriesDetails/ReminderCategoriesDetails';
import ReminderCategoriesList from './components/reminderCategoriesList/ReminderCategoriesList';
import styles from './ReminderCategoriesTab.module.scss';

const ReminderCategoriesTab = () => {
    const { type } = useParams<{ type: string, itemId: string }>();
    
    return <div className={styles.container}>
        {
            (type === 'list' ? <ReminderCategoriesList /> : <ReminderCategoriesDetails />)
        }
        </div>;
}

export default ReminderCategoriesTab;
